import { render, staticRenderFns } from "./FormCeklis.vue?vue&type=template&id=fbff959e&"
import script from "./FormCeklis.vue?vue&type=script&lang=js&"
export * from "./FormCeklis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports